import Vue from 'vue';
import VueI18n from 'vue-i18n';
import moment from 'moment/moment';
import internationalization from '../lang';
import 'moment/locale/pl';
import 'moment/locale/en-gb';

Vue.use(VueI18n);

const options = {
  locale: localStorage.getItem('lang') || 'pl',
  messages: internationalization
};

const i18n = new VueI18n(options);

moment.locale(options.locale === 'pl' ? 'pl' : 'en-gb');

export default i18n;
